module.exports = __webpack_public_path__ + "fonts/DM_Sans-100-latin3.7c87a64.woff2";